import React, { useEffect, useState } from "react";
import { Moon, Sun } from "lucide-react";
import { getActiveTheme, setTheme } from "@/lib/theme";

// Compact light/dark toggle. Designed to sit in the app header.
export const ThemeToggle = ({ className = "" }) => {
  const [theme, setThemeState] = useState(() => getActiveTheme());

  useEffect(() => {
    // Keep the icon in sync with the <html> class, including when the automatic
    // night mode flips the theme in the background.
    const root = document.documentElement;
    const sync = () => setThemeState(root.classList.contains("dark") ? "dark" : "light");
    sync();
    const obs = new MutationObserver(sync);
    obs.observe(root, { attributes: true, attributeFilter: ["class"] });
    return () => obs.disconnect();
  }, []);

  const toggle = () => {
    const next = theme === "dark" ? "light" : "dark";
    setTheme(next);
    setThemeState(next);
  };

  const isDark = theme === "dark";

  return (
    <button
      type="button"
      onClick={toggle}
      title={isDark ? "Passer en mode clair" : "Passer en mode nuit"}
      aria-label={isDark ? "Passer en mode clair" : "Passer en mode nuit"}
      className={`flex h-8 w-8 items-center justify-center rounded-lg text-muted-foreground transition-colors hover:bg-muted hover:text-primary ${className}`}
      data-testid="theme-toggle-button"
    >
      {isDark ? <Sun className="h-[18px] w-[18px]" /> : <Moon className="h-[18px] w-[18px]" />}
    </button>
  );
};
